module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/rory/Sites/deblois-electric/wp-content/themes/sage/node_modules/core-js/modules/_library.js
// module id = 30
// module chunks = 0